import url from './url';



export default url(() => '/images/reserve-statistics');
